/**
 * Auth API
 * Handles authentication endpoints
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseAPI } from "./base-api";
export class AuthAPI extends BaseAPI {
    /**
     * Login to ME Protocol (creates account if new user)
     */
    meProtocolLogin(email, walletAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.post(`${this.env.API_URL}auth/sdk/login`, {
                    walletAddress,
                    email,
                });
                return data;
            }
            catch (error) {
                console.error("Error in ME Protocol login:", error);
                throw error;
            }
        });
    }
}
